/** Rome time helpers for the UI (all conversions go through `core`, never the device time zone). */
import { fromRome, toRome } from 'core';
import type { IsoDate, IsoDateTime } from 'core';

export {
  addDays,
  formatDate,
  formatDateTime,
  formatDayMonth,
  formatTime,
  fromRome,
  romeDate,
  romeNow,
  toRome,
  weekdayNameIt,
} from 'core';

/** Today's date in Rome. */
export function todayRome(): IsoDate {
  return toRome(new Date()).date;
}

/** ISO instant → value for `<input type="datetime-local">` (Rome wall time). */
export function toDateTimeLocal(iso: IsoDateTime): string {
  const r = toRome(iso);
  return `${r.date}T${r.time}`;
}

/** `<input type="datetime-local">` value (Rome wall time) → ISO instant; null if empty/invalid. */
export function fromDateTimeLocal(value: string): IsoDateTime | null {
  const m = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/.exec(value);
  if (!m) return null;
  try {
    return fromRome(m[1]!, m[2]!);
  } catch {
    return null;
  }
}
